import { SVGProps } from 'react';
const SvgSortDescending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4 17h12M4 12h9M4 7h6M18 13V5M21 8l-3-3-3 3"
    />
  </svg>
);
export default SvgSortDescending;
